import { render } from "./DuplicateModal.vue?vue&type=template&id=6e9cedd2"
import script from "./DuplicateModal.vue?vue&type=script&lang=js"
export * from "./DuplicateModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__